export default __webpack_public_path__ + "static/media/myc-staking.36a0d16a.svg";